import { Component } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { InstructionsComponent } from '../instructions/instructions.component';
import { PrioritizeUserComponent } from './prioritize-user/prioritize-user.component';
import { SkippedUserComponent } from './skipped-user/skipped-user.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-user-tinder',
  standalone: false,
  templateUrl: './user-tinder.component.html',
  styleUrl: './user-tinder.component.scss'
})
export class UserTinderComponent {
  thisStepCount: number = 0;
  totalStepCount: number = 0;
  progress: number = 0;
  nextBtnDisabledStatus: boolean = true;
  stepId: any;
  streamId: any;

  stream: any;
  step: any;

  personas = [
    {
      name: "Lena Leaf",
      description: "Lena is 32 years old. Living in Eco Valley. She is a strong advocate for zero-waste living, enjoys hiking, and experiments with plant-based cooking.",
      tags: [{ name: "Zero-Waste Advocate" }],
      image: "",
      personaId: ""
    },
    {
      name: "Sammy Solar",
      description: "Lorem ipsum",
      tags: [{ name: "Zero-Waste Advocate" }],
      image: ""
    },
    {
      name: "Bobby",
      description: "Lorem ipsum",
      tags: [{ name: "Zero-Waste Advocate" }],
      image: ""
    }
  ]
  positivePersonas: any[] = [];
  negativePersonas: any[] = [];
  skippedPersonas: any[] = [];


  personaQueue: any[] = []

  constructor(
    private appData: AppdataService,
    private route: ActivatedRoute,
    private instructionsDialog: MatDialog,
    private prioritizeModal: MatDialog,
    private skippedDialog: MatDialog,
  ) {
    route.queryParams.subscribe(async (params) => {
      this.stepId = await params['stepId'];
      this.streamId = await params['streamId'];
    });

    appData.tracks.subscribe(async (data) => {
      for await (const track of data) {
        for await (const stream of track.streams) {
          if (stream.id === this.streamId) {
            this.stream = stream;
            this.step = await stream.steps.find((step: any) => step.id === this.stepId);

            this.totalStepCount = stream.steps.length;
            this.thisStepCount = this.step.orderNr

            let pro = this.thisStepCount / this.totalStepCount;
            this.progress = pro * 100;

            console.log('Stream:', this.stream);
            console.log('Step:', this.step);

          }
        }
      }
    });
    this.personaQueue = this.personas;
  }

  async openInstructions() {
    let dia = await this.instructionsDialog.open(InstructionsComponent, {
      data: { for: 'userTinder' },
      width: '500px'
    });

    dia.afterClosed().subscribe((result) => { })
  }
  matchPersona() {
    this.positivePersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
    
    if (this.positivePersonas.length > 0) {
      this.nextBtnDisabledStatus = false;
    }
  }

  noMatchPersona() {
    this.negativePersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
  }

  skipPersona() {
    this.skippedPersonas.push(this.personaQueue[0]);
    this.personaQueue = this.personaQueue.filter((p) => p !== this.personaQueue[0]);
  }

  removeSelection(persona: any) {
    this.positivePersonas = this.positivePersonas.filter((p) => p !== persona);
    this.negativePersonas = this.negativePersonas.filter((p) => p !== persona);
    this.personaQueue.push(persona);
  }



  async showSkipped() {
    let dia = await this.skippedDialog.open(SkippedUserComponent, {
      data: { personas: this.skippedPersonas }
    })

    dia.afterClosed().subscribe((result) => {
      if (result) {
        result.positive.forEach((p: any) => {
          this.positivePersonas.push(p)
        });
        result.negative.forEach((p: any) => {
          this.negativePersonas.push(p)
        });
        this.skippedPersonas = result.skipped
      }
    })
  }

  async nextStep() {
    if (this.positivePersonas.length > 1) {
      let dia = await this.prioritizeModal.open(PrioritizeUserComponent, {
        data: { personas: this.positivePersonas },
        width: '500px',
        maxHeight: '60vh'
      });

      dia.afterClosed().subscribe((result) => {
        if (result == true) {

        }
      })
    }
  }

}
